import React, { useState, useEffect } from "react";
import useSessionStorage from "./Session";

interface FeatureTableProps {
  featureData_0: { [key: string]: string };
  featureData_1: { [key: string]: string };
  featureData_2: { [key: string]: string };
}

const FeatureTable: React.FC<FeatureTableProps> = ({ featureData_0, featureData_1, featureData_2 }) => {
  const [selectedFeature, setSelectedFeature] = useSessionStorage<any>("selectedFeature", null);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedFeature = JSON.parse(sessionStorage.getItem("selectedFeature") || "null");

      // Update state only if the value has changed
      setSelectedFeature((prevFeature: any) =>
        JSON.stringify(prevFeature) !== JSON.stringify(storedFeature) ? storedFeature : prevFeature
      );
    }, 500); // Check sessionStorage every 500ms

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  // Store the datasets in an array to process dynamically
  const datasets = [
    { name: "Fresh Surface Water Viability", data: featureData_2 },
    { name: "Fresh Groundwater Viability", data: featureData_0 },
    { name: "Brackish Groundwater Viability", data: featureData_1 },
  ];

  // Filter out empty datasets
  const availableDatasets = datasets.filter((dataset) => Object.keys(dataset.data || {}).length > 0);

  // If no datasets are available or no feature is selected, show a message
  if (availableDatasets.length === 0) return <p>No data available</p>;
  
  const localFeature = selectedFeature;
  if (!localFeature) return <p style={{ padding: '15px', textAlign: 'center' }}>No feature selected</p>;
  
  return (
    <div style={{ padding: '15px' }}>
      <h3 style={{ 
        color: '#4a5568', 
        fontSize: '16px', 
        fontWeight: '600', 
        marginBottom: '15px',
        marginTop: '0px'
      }}>Selected Polygon Data</h3>
      
      {/* Feature Properties */}
      <table style={{ 
        width: '100%', 
        borderCollapse: 'collapse',
        marginBottom: '20px'
      }}>
        <thead>
          <tr>
            <th style={{ 
              padding: '8px 0', 
              textAlign: 'left', 
              color: '#4a5568',
              fontWeight: '600',
              fontSize: '14px'
            }}>ID</th>
            <th style={{ 
              padding: '8px 0', 
              textAlign: 'left', 
              color: '#4a5568',
              fontWeight: '600',
              fontSize: '14px'
            }}>Name</th>
            <th style={{ 
              padding: '8px 0', 
              textAlign: 'left', 
              color: '#4a5568',
              fontWeight: '600',
              fontSize: '14px'
            }}>Code</th>
            <th style={{ 
              padding: '8px 0', 
              textAlign: 'left', 
              color: '#4a5568',
              fontWeight: '600',
              fontSize: '14px'
            }}>Area(m²)</th>
          </tr>
        </thead>
        <tbody >
          <tr>
            <td style={{ padding: '8px 0', fontSize: '14px', color: '#1976d2', fontWeight: "bold"  }}>
              {localFeature.id || "N/A"}
            </td>
            <td style={{ padding: '8px 0', fontSize: '14px', color: '#1976d2', fontWeight: "bold"  }}>
              {localFeature.properties?.name || "N/A"}
            </td>
            <td style={{ padding: '8px 0', fontSize: '14px', color: '#1976d2', fontWeight: "bold" }}>
              {localFeature.properties?.statefp || "N/A"}
            </td>
            <td style={{ padding: '8px 0', fontSize: '14px', color: '#1976d2', fontWeight: "bold" }}>
              {localFeature.properties?.area_m2 ? 
                localFeature.properties.area_m2.toExponential(3) : "N/A"}
            </td>
          </tr>
        </tbody>
      </table>
      
      <h3 style={{ 
        color: '#4a5568', 
        fontSize: '16px', 
        fontWeight: '600', 
        marginBottom: '15px',
        borderTop: '1px solid #e2e8f0',
        paddingTop: '15px'
      }}>Dataset Values</h3>
      
      {/* Viability Values - Vertical Layout */}
      <table style={{ 
        width: '100%', 
        borderCollapse: 'collapse'
      }}>
        <tbody>
          {datasets.map((dataset, index) => (
            <tr key={index}>
              <td style={{ 
                padding: '10px 0', 
                fontSize: '14px', 
                borderBottom: '1px solid #e2e8f0',
                color: '#4a5568',
                width: '70%'
              }}>{dataset.name}</td>
              <td style={{ 
                padding: '10px 0', 
                fontSize: '14px', 
                textAlign: 'right',
                borderBottom: '1px solid #e2e8f0',
                color: '#1a56db',
                fontWeight: "bold"
              }}>{dataset.data[localFeature.id] || "Unknown"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FeatureTable;